/**
 * PawLink brand mark + wordmark component.
 *
 * All variants are composed from ONLY the truly transparent icon PNG
 * (dog head + white P outline, no box, no squircle) + inline HTML text.
 *
 * The dark-squircle app-icon-*.png is reserved ONLY for the phone's
 * home-screen app icon / favicon — never used as an in-app logo.
 *
 * Variants:
 *   - mark:    icon only
 *   - full:    icon + "PawLink" wordmark side-by-side (horizontal)
 *   - stacked: icon on top, "PawLink" text below (splash / login hero)
 */
export function PawLinkLogo({
    variant = "mark",
    size = 40,
    className = "",
    withGlow = true,
    "data-testid": testId = "pawlink-logo",
}) {
    const glowStyle = withGlow
        ? { filter: "drop-shadow(0 8px 22px rgba(248, 122, 42, 0.35))" }
        : undefined;

    const IconImg = (
        <img
            src="/brand/icon-transparent-512.png"
            alt="PawLink"
            draggable={false}
            className="select-none pointer-events-none object-contain"
            style={{ width: size, height: size, ...glowStyle }}
        />
    );

    const wordmarkClass = (px) =>
        `font-display leading-none tracking-tight font-medium select-none whitespace-nowrap`;

    // Text sizing scales with icon size for consistent visual weight
    const textSizePx = Math.round(size * 0.72);

    if (variant === "full") {
        return (
            <span
                data-testid={testId}
                className={`inline-flex items-center gap-3 notranslate ${className}`}
                translate="no"
            >
                {IconImg}
                <span className={wordmarkClass()} style={{ fontSize: textSizePx }} dir="ltr" translate="no">
                    <span className="text-white">Paw</span><span className="bg-gradient-to-r from-[#F87A2A] to-[#FF8A00] bg-clip-text text-transparent">Link</span>
                </span>
            </span>
        );
    }

    if (variant === "stacked") {
        const stackedTextSize = Math.round(size * 0.42);
        return (
            <span
                data-testid={testId}
                className={`inline-flex flex-col items-center gap-4 notranslate ${className}`}
                translate="no"
            >
                {IconImg}
                <span className={wordmarkClass()} style={{ fontSize: stackedTextSize }} dir="ltr" translate="no">
                    <span className="text-white">Paw</span><span className="bg-gradient-to-r from-[#F87A2A] to-[#FF8A00] bg-clip-text text-transparent">Link</span>
                </span>
            </span>
        );
    }

    // default: mark only
    return (
        <span
            data-testid={testId}
            className={`inline-block notranslate ${className}`}
            style={{ width: size, height: size }}
            translate="no"
        >
            {IconImg}
        </span>
    );
}

export default PawLinkLogo;
